<template>
  <div class="device-new">
    <div style="margin-bottom:.8rem">
      <el-button @click="addDevice" size="small" type="success" icon="el-icon-plus">添加设备</el-button>
    </div>
    <div v-for="(msg,index) in deviceDate" :key="index" class="device-new-box">
      <div class="device-new">
        <span class="trend-title">设备名称</span>
        <el-input show-word-limit maxlength="20" type="text" placeholder="请输入" v-model="msg.devName"></el-input>
        <el-button @click="removeDevice(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
      <div class="device-new">
        <span class="trend-title">设备照片</span>
        <div style="display:inline-block;">
          <el-upload 
            class="avatar-uploader"  
            :http-request="(e)=>{uploadfile(e,index)}" 
            action="#" 
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <img v-if="msg.devImg" :src="msg.devImg" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="device-new">
        <span class="trend-title">设备介绍</span>
        <el-input show-word-limit maxlength="300" :rows="4" type="textarea" placeholder="请输入" v-model="msg.devRemark"></el-input>    
      </div>
    </div>
    <div class="last-save">
      <el-button :loading="newLoading" size="small" @click="saveNew" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import upapi from '@/apis/upload'
import api from '@/apis/device/device'
export default {
  data(){
    return{
      newLoading:false,//加载状态
      deviceDate:[
        {devName:'',devImg:'',devRemark:''}
      ]
    }
  },
  mounted(){
    this.getNew()
  },
  methods:{
    //获取数据
    getNew(){
      api.getNewDev().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.deviceDate = res.data
          }
        }
      })
    },
    //保存
    saveNew(){
      this.newLoading = true;
      api.saveNewDev(this.deviceDate).then(res=>{
        if(res.code==10000){
          this.newLoading = false;
          this.getNew()
          this.$message.success("保存成功")
        }else{
          this.newLoading = false;
          this.$message.error(res.message);
          return;
        }
      })
    },
    //删除设备
    removeDevice(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delNewDev([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getNew()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.deviceDate.splice(index,1)
      }
    },
    //图片上传成功的回调函数
    uploadfile(val,i) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.deviceDate[i].devImg = res.data
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },
    //判断上传文件格式是否合法
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    //添加设备
    addDevice(){
      this.deviceDate.push({devName:'',devImg:'',devRemark:''})
    },
  }
}
</script>
<style lang="less" scoped>
.device-new{ padding-top: 10px;
  .device-new-box{ display:inline-block; width: 45%; padding:1rem; margin-right:1rem; margin-bottom: 1rem; border: #3570ff solid 1px;
    .device-new{ margin-bottom: 15px; display: flex; flex-direction: row;
      .el-input,.el-select,.el-textarea{ flex: 1;}
    }
  }
}
</style>